<template>
  <a-drawer width="45%" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ $t('用户实名认证.详情') }}</b>
    </a-divider>
    <a-descriptions :column="1" bordered size="default">
      <a-descriptions-item :label="$t('用户实名认证.用户昵称')">{{ form.nickName || '-' }}</a-descriptions-item>
      <a-descriptions-item :label="$t('用户实名认证.手机号')">{{ form.mobile || '-' }}</a-descriptions-item>
      <a-descriptions-item :label="$t('用户实名认证.姓名')">{{ form.realName || '-' }}</a-descriptions-item>
      <a-descriptions-item :label="$t('用户实名认证.身份证号')">{{ form.idCard || '-' }}</a-descriptions-item>
      <a-descriptions-item :label="$t('用户实名认证.身份证人像面')">
        <a v-if="form.idCardFront" @click="handlePreview(form.idCardFront)">
          <img :src="form.idCardFront" style="width: 160px; height: auto;" />
        </a>
        <span v-else>-</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('用户实名认证.身份证国徽面')">
        <a v-if="form.idCardBack" @click="handlePreview(form.idCardBack)">
          <img :src="form.idCardBack" style="width: 160px; height: auto;" />
        </a>
        <span v-else>-</span>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('用户实名认证.审核状态')">
        <custom-dict-tag :options="customDict.UserRealNameStatusEnum" :value="form.certificationStatus" />
      </a-descriptions-item>
      <a-descriptions-item :label="$t('用户实名认证.审核意见')">{{ form.certificationOpinion || '-' }}</a-descriptions-item>
      <a-descriptions-item :label="$t('用户实名认证.审核人')">{{ form.examinerName || '-' }}</a-descriptions-item>
      <a-descriptions-item :label="$t('用户实名认证.审核时间')">{{ parseTime(form.examineTime) }}</a-descriptions-item>
      <a-descriptions-item :label="$t('用户实名认证.创建时间')">{{ parseTime(form.createTime) }}</a-descriptions-item>
    </a-descriptions>
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="preview" style="width: 100%" :src="previewImage" />
    </a-modal>
  </a-drawer>
</template>

<script>
import { getRealName } from '@/api/userRealName/realName'
import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'

export default {
  name: 'DetailForm',
  components: {
    CustomDictTag
  },
  data () {
    return {
      open: false,
      previewVisible: false,
      previewImage: '',
      form: {}
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    onClose () {
      this.open = false
    },
    /** 详情按钮操作 */
    handleDetail (row) {
      getRealName({ id: row.id }).then(response => {
        this.form = response.data
        this.open = true
      })
    },
    handlePreview (url) {
      this.previewImage = url
      this.previewVisible = true
    }
  }
}
</script>
